<template>
  <div id="info" ref="index">
    <section class="form">
      <div class="container">
        <!-- 標題 -->
        <div class="form-header">
          <router-link
            :to="{name: 'career'}"
            class="text-primary d-inline-flex align-items-center pr-3"
          >
            <i class="material-icons">arrow_left</i>
            <strong>BACK</strong>
          </router-link>
          <h2 class="text-secondary mt-30">徵才資訊</h2>
        </div>
        <main>
          <h1 class="text-primary h4">{{job.title}}</h1>
          <article>
            <div class="content" v-html="job.content"></div>
          </article>
        </main>
      </div>
    </section>
    <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'info',
  data() {
    return {
      job: {},
    };
  },
  methods: {
    getInfo() {
      const loading = this.$loading.show({
        container: this.$refs.category,
      });
      const url = `/article/${this.$route.params.id}`;
      this.axios
        .get(url)
        .then((response) => {
          this.job = response.data.data;
          if (this.job.content.match(/^pre/g) !== undefined) {
            this.job.content = this.job.content.replace(new RegExp('pre>', 'ig'), 'div>');
          }
          loading.hide();
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
          loading.hide();
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getInfo();
    this.$nextTick(() => {
      setTimeout(() => {
        this.scrollToTop();
      }, 500);
    });
  },
};
</script>
<style lang="scss">
@import '~@/assets/scss/all.scss';
#info {
  @media (min-width: 992px) {
    background-image: url('~@/assets/images/bg-circle-left.svg'),
      url('~@/assets/images/bg-circle-right.svg');
    background-size: 170px auto, 170px auto;
    background-repeat: repeat-y, repeat-y;
    background-position: left top, right top;
  }
  .icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: $primary;
  }
  section {
    min-height: 450px;
    padding: 40px 0;
    background-color: rgba(255, 255, 255, 0.5);
    a {
      color: #000000;
      text-decoration: none;
    }
    &.form {
      padding-bottom: 50px;
      .form-header {
        position: relative;
        a {
          font-size: 15px;
          background-color: #fff;
          z-index: 1;
          text-decoration: none;
          i {
            font-size: 40px;
          }
          &::before {
            content: '';
            position: absolute;
            background-color: $primary;
            left: 0;
            right: 0;
            top: 19px;
            height: 4px;
            z-index: -1;
          }
        }
      }
      main {
        border: 1px solid $secondary-white;
        border-radius: 20px;
        padding: 50px 80px;
        margin: 50px auto;
        background-color: white;
        h1 {
          letter-spacing: 5px;
          padding-bottom: 20px;
          border-bottom: 2px dashed $secondary-white;
        }
        article {
          margin: 20px 0;
          color: $secondary;
          div {
            line-height: 1.75em;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}
</style>
